import { SalesforceConfig } from 'module/api/integrations/salesforce/types';
import { IntegrationStatusTypes } from 'module/api/integrations/salesforce/types';
import { PageLoading } from 'module/ui/components/atoms/loading/index';
import { Navigate } from '@rocketlane/rocket-router';
import { useSalesforceConfigQuery } from 'queries/salesforce';
import { getSalesforceBaseUrl, getSalesforceAutomationUrl } from './utils/urls';

const getConfig = (data?: SalesforceConfig[]) => data?.[0];

export const AutomaticRedirection = () => {
  const { data, status } = useSalesforceConfigQuery();

  switch (status) {
    case 'pending': {
      return <PageLoading />;
    }
    case 'success': {
      const config = getConfig(data);

      if (config) {
        if (config.integrationStatus === IntegrationStatusTypes.Expired) {
          return (
            <Navigate
              to={`${getSalesforceBaseUrl(config.integrationId.toString())}/settings`}
              replace
            />
          );
        }

        return (
          <Navigate
            to={getSalesforceAutomationUrl(config.integrationId.toString())}
            replace
          />
        );
      }

      return (
        <Navigate to={`${getSalesforceBaseUrl('new')}/settings`} replace />
      );
    }
    case 'error': {
      return (
        <Navigate to={`${getSalesforceBaseUrl('new')}/settings`} replace />
      );
    }
    default: {
      return null;
    }
  }
};
